import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Box, Toolbar, Typography } from '@mui/material';

const Privacy = () => {
    const { t } = useLanguage();
    return (
        <Box>
            <Toolbar>
                <div className='terms-screen'>
                    <div className='disclainerWrapper'>
                        <Typography variant='h2'>{t('privacy_title')}</Typography>
                       
                        <div className='tems-condition-content'>
                            <div className='terms-heading'>
                                 <Typography variant='body1'>{t('privacy_text')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>1. Purpose and Scope</Typography>
                                <Typography variant='body1'>The App is intended to:</Typography>
                                <ul>
                                    <li>Facilitate early screening of OPMDs and oral cancer</li>
                                    <li>Improve awareness regarding oral health and risk factors</li>
                                    <li>Support academic, clinical, and public health research</li>
                                </ul>
                                 <Typography variant='body1'>The App provides screening support only and does not provide definitive diagnosis or treatment recommendations.</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>2. Information We Collect </Typography>
                                <Typography variant='body1'>a. Demographic Information </Typography>
                                <ul>
                                    <li>Age or age group</li>
                                    <li>Gender</li>
                                    <li>District/state </li>
                                </ul>
                                <Typography variant='body1'>b. Health and Clinical Information</Typography>
                                <ul>
                                    <li>Oral examination findings</li>
                                    <li>Tongue and oral cavity lesion details</li>
                                    <li>Mouth opening measurements (where applicable) </li>
                                    <li>Duration of symptoms</li>
                                    <li>Risk factors such as tobacco, areca nut, smoking, and alcohol use </li>
                                </ul>
                                <Typography variant='body1'>c. Images and Media</Typography>
                                <ul>
                                    <li>Intraoral photographs captured or uploaded by users only after informed consent</li>
                                    <li>Images are limited to the oral cavity and do not intentionally capture facial identity</li>
                                </ul>
                                <Typography variant='body1'>d. Technical Information</Typography>
                                <ul>
                                    <li>Device type and operating system</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>3. Lawful Basis for Data Collection</Typography>
                                <Typography variant='body1'>Data is collected based on:</Typography>
                                <ul>
                                    <li>
                                        Voluntary informed consent of the user
                                    </li>
                                    <li>
                                        Compliance with applicable Indian data protection and ethical research guidelines
                                    </li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>4. Use of Collected Information</Typography>
                                <Typography variant='body1'>Information collected through the App is used exclusively for:</Typography>
                                <ul>
                                    <li>Screening and risk stratification of OPMDs and oral cancer</li>
                                    <li>Identifying individuals who may require referral to healthcare facilities</li>
                                    <li>Research, audit, and academic publication (in anonymized form)</li>
                                    <li>Improving App performance and screening accuracy</li>
                                    <li>Collected data will be used in anonymized form for research, patient education and awareness, and further improvement of the mobile application.</li>
                                </ul>
                                <Typography variant='body1'>No data is used for commercial advertising, profiling, or sale.</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>5. Data Storage and Security Measures</Typography>
                                <ul>
                                    <li>Data is stored on secure, access-controlled servers</li>
                                    <li>Encryption and password protection are employed where feasible</li>
                                    <li>Access is restricted to authorized investigators, clinicians, or technical personnel</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>6. Data Sharing and Disclosure</Typography>
                                <Typography variant='body1'>User data is not sold, rented, or shared with third parties for commercial purposes.</Typography>
                                <Typography variant='body1'>Data may be disclosed only:</Typography>
                                <ul>
                                    <li>In anonymized or aggregated form for scientific publications or presentations</li>
                                    <li>To ethics committees, funding agencies, or regulatory bodies when required</li>
                                    <li>To healthcare professionals for referral, only with user consent</li>
                                    <li>When mandated by law</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>7. Data Retention</Typography>
                                <ul>
                                    <li>Identifiable data is retained only for the duration necessary to meet screening or research objectives</li>
                                    <li>Data may be archived in anonymized form in accordance with institutional and ethical requirements</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>8. User Rights</Typography>
                                <Typography variant='body1'>Subject to applicable laws, users have the right to:</Typography>
                                <ul>
                                    <li>Access their personal data</li>
                                    <li>Request correction of inaccurate information</li>
                                    <li>Request deletion of identifiable data, where permissible</li>
                                    <li>Withdraw consent at any time without affecting their access to care</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>9. Children and Vulnerable Populations</Typography>
                                <Typography variant='body1'>Subject to applicable laws, users have the right to:</Typography>
                                <ul>
                                    <li>The App is not intended for use by individuals below 18 years of age without parental or guardian consent</li>
                                    <li>Additional safeguards are applied when screening vulnerable populations</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>10. Ethical Compliance</Typography>
                                <Typography variant='body1'>This App is developed and operated in accordance with:</Typography>
                                <ul>
                                    <li>Institutional Ethics Committee (IEC) approval</li>
                                    <li>ICMR National Ethical Guidelines for Biomedical and Health Research Involving Human Participants (2017, updated 2023)</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>11. Legal Compliance </Typography>
                                <Typography variant='body1'>The App complies with applicable laws and standards, including:</Typography>
                                <ul>
                                    <li>Information Technology Act, 2000 (India)</li>
                                    <li>Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011</li>
                                    <li>Digital Personal Data Protection (DPDP) Act, 2023 (India)</li>
                                    <li>WHO guidelines on oral cancer prevention and early detection</li>
                                </ul>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>12. Changes to This Privacy Policy </Typography>
                                <Typography variant='body1'>We reserve the right to update this Privacy Policy periodically. Updates will be reflected within the App.</Typography>
                            </div>
                             <div className='terms-heading'>
                                <Typography variant='h4'>13.Acknowledgement and Acceptance </Typography>
                                <Typography variant='body1'>By clicking “I Understand”, “I Agree”, or by continuing to use this Application, you confirm that:</Typography>
                                <ul>
                                    <li>You have read and understood this Privacy Policy</li>
                                    <li>You voluntarily consent to the collection and use of your information as described</li>
                                    <li>You agree to be bound by the terms of this Privacy Policy</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Toolbar>
        </Box>
    );
};

export default Privacy;